import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import $ from "jquery";
import { Popover } from "antd";
import "antd/dist/antd.css";
import axios from "axios";
import FontFaceObserver from "fontfaceobserver";
import {SwainColorHex} from "../ColorCodeHelper";

class MatsToolbar extends React.Component {
  state={
    x: 0,
    y: 0,
    visible:'hidden',
  }
  addNewRect = (e, type, color, colorCode) => {
    const {swain_config} = this.props;
    const data = {
      mat_type: type,
      mat_color: colorCode
    };

    let width = 0;
    let height = 0;
    const unit = swain_config.length_unit === "FEET"?3.28:1;

    switch (type) {
      case 1:
        width = this.props.canvas_grid * 2 * unit * this.props.zoom;
        height = this.props.canvas_grid * unit * this.props.zoom;
        break;
      case 2:
        width = this.props.canvas_grid * unit * this.props.zoom;
        height = this.props.canvas_grid * 2 * unit * this.props.zoom;
        break;
      case 3:
        width = this.props.canvas_grid * unit * this.props.zoom;
        height = this.props.canvas_grid * unit * this.props.zoom;
        break;
      default:
        break;
    }

    this.props.setNewRectConfig(data);
    this.props.setDragRect(true);

    let $img = $("<img />", {
      src: require("./../../../assets/img/" + color + "_" + type + ".jpg"),
      id: "dragged_image",
      width: width,
      height: height,
      display:"none"
    });
    $("#drag_image").html($img);

    //width = $("#dragged_image").css("width");
    //height = $("#dragged_image").css("height");
    const scrollTop = document.documentElement.scrollTop / 1
    const top = e.pageY - height / 2 - scrollTop ;
    const left = e.pageX - width / 2;
    console.log({top,left});
    $("#dragged_image").css({
      position: "fixed",
      top: top,
      left: left
    });
    let previewed_image = $("<img />", {
      src: require("./../../../assets/img/preview.png"),
      id: "previewed_image",
      width: width,
      height: height,
    });
    $("#preview_image").html(previewed_image);
    $('#previewed_image').css({
      display: 'none',
    })
    document.getElementById("mySidenav1").style.width = "0";
    document.getElementById("mySidenav2").style.width = "0";
    document.getElementById("mySidenav3").style.width = "0";
    document.getElementById("mySidenav4").style.width = "0";
  };
  checkBrowser=()=>{
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };
  _mouseOver=(e)=>{
    if(this.checkBrowser()) return;
    let boundingBox = e.target.getBoundingClientRect();
    $("#tooltipmat").css({top:boundingBox.top+boundingBox.height , left:boundingBox.left+boundingBox.width,visibility:'visible' });
  }
  _mouseOut=()=>{
    if(this.checkBrowser()) return;
    $("#tooltipmat").css({visibility:'hidden' });
  }
  render() {
    return (
      <>
        <div className="adddiv">
          <h2>Mats</h2>
        </div>
        <div className="matlist_main">
          <ul className="matlistul">
            <li>
              <span className="mat-caption">Royal Blue</span>
              <span className="mat-images">
                <div
                    className="tooltip"
                >
                  <img
                      src={require("./../../../assets/img/blue_1.jpg")}
                      alt="Royal Blue"
                      onDragStart={e => this.addNewRect(e, 1, "blue","RoyalBlue")}
                  />
                  </div>
                <div
                    className="tooltip"
                >
                  <img
                      src={require("./../../../assets/img/blue_2.jpg")}
                      alt="Royal Blue"
                      onDragStart={e => this.addNewRect(e, 2, "blue","RoyalBlue")}
                  />
                  </div>
                <div
                    className="tooltip"
                >
                  <img
                      src={require("./../../../assets/img/blue_3.jpg")}
                      alt="Royal Blue"
                      onDragStart={e => this.addNewRect(e, 3, "blue","RoyalBlue")}
                  />
                  </div>


              </span>
            </li>
            <li>
              <span className="mat-caption">Red</span>
              <span className="mat-images">
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/red_1.jpg")}
                      alt="RED"
                      onDragStart={e => this.addNewRect(e, 1, "red","Red")}
                  />
                  </div>
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/red_2.jpg")}
                      alt="RED"
                      onDragStart={e => this.addNewRect(e, 2, "red","Red")}
                  />
                  </div>
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/red_3.jpg")}
                      alt="RED"
                      onDragStart={e => this.addNewRect(e, 3, "red","Red")}
                  />
                  </div>
              </span>
            </li>
            <li>
              <span className="mat-caption">Gold</span>
              <span className="mat-images">
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/gold_1.jpg")}
                      alt="Gold"
                      onDragStart={e => this.addNewRect(e, 1, "gold","Gold")}
                  />
                  </div>
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/gold_2.jpg")}
                      alt="Gold"
                      onDragStart={e => this.addNewRect(e, 2, "gold","Gold")}
                  />
                  </div>
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/gold_3.jpg")}
                      alt="Gold"
                      onDragStart={e => this.addNewRect(e, 3, "gold","Gold")}
                  />
                  </div>
              </span>
            </li>
            <li>
              <span className="mat-caption">Black</span>
              <span className="mat-images">
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/black_1.jpg")}
                      alt="Black"
                      onDragStart={e => this.addNewRect(e, 1, "black","Black")}
                  />
                  </div>
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/black_2.jpg")}
                      alt="Black"
                      onDragStart={e => this.addNewRect(e, 2, "black","Black")}
                  />
                  </div>
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/black_3.jpg")}
                      alt="Black"
                      onDragStart={e => this.addNewRect(e, 3, "black","Black")}
                  />
                  </div>
              </span>
            </li>
            <li>
              <span className="mat-caption">Gray</span>
              <span className="mat-images">
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/gray_1.jpg")}
                      alt="Grey"
                      onDragStart={e => this.addNewRect(e, 1, "gray","Gray")}
                  />
                  </div>
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/gray_2.jpg")}
                      alt="Grey"
                      onDragStart={e => this.addNewRect(e, 2, "gray","Gray")}
                  />
                  </div>
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/gray_3.jpg")}
                      alt="Grey"
                      onDragStart={e => this.addNewRect(e, 3, "gray","Gray")}
                  />
                  </div>
              </span>
            </li>
            <li>
              <span className="mat-caption" style={{ textAlign: "left" }}>
                Light Green
              </span>
              <span className="mat-images">
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/lightgreen_1.jpg")}
                      alt="Green"
                      onDragStart={e => this.addNewRect(e, 1, "lightgreen","LightGreen")}
                  />
                  </div>
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/lightgreen_2.jpg")}
                      alt="Green"
                      onDragStart={e => this.addNewRect(e, 2, "lightgreen","LightGreen")}
                  />
                  </div>
                <div className="tooltip">
                  <img
                      src={require("./../../../assets/img/lightgreen_3.jpg")}
                      alt="Green"
                      onDragStart={e => this.addNewRect(e, 3, "lightgreen","LightGreen")}
                  />
                  </div>
              </span>
            </li>
          </ul>
        </div>
      </>
    );
  }
}

const setNewRectConfig = data => {
  return {
    type: "NEW_RECT_CONFIG",
    data: data
  };
};

const setDragRect = drag_new_rect => {
  return {
    type: "DRAG_NEW_RECT",
    drag_new_rect: drag_new_rect
  };
};



const mapStateToProps = state => {
  return {
    components: [...state.components],
    _config: state._config,
    canvas: state.canvas,
    canvas_grid: state.canvas_grid,
    templates: state.templates,
    logo_url: state.logo_url,
    templates_width: state.templates_width,
    swain_config: state.swain_config,
    zoom: state.zoom,
    selectedMaterialColor:state.selectedMaterialColor
  };
};

const mapDispatchToPropsForRect = dispatch => {
  return bindActionCreators({ setNewRectConfig, setDragRect , setCanvasConfig , setSelectedMaterialColor , removeRect}, dispatch);
};

const MatsToolbarConnect = connect(
  mapStateToProps,
  mapDispatchToPropsForRect
)(MatsToolbar);

class MatsToolSidebar extends React.Component {
  closeNav1 = () => {
    document.getElementById("mySidenav1").style.width = "0";
  };

  render() {
    return (
      <>
        <div id="mats" className="h100 second-menu fordeskview">
          <MatsToolbarConnect />
        </div>
        <div
          className="text-center h100 pad0 mtopneg sidenav1 formobview wo"
          id="mySidenav1"
        >
          <a
            style={{ color: "#fff" }}
            href="#"
            className="closebtn"
            onClick={() => this.closeNav1()}
          >
            &times;
          </a>
          <MatsToolbarConnect />
        </div>
      </>
    );
  }
}

class EditArtWorkToolbar extends React.Component {
  state={
    x: 0,
    y: 0,
    visible:'hidden',
  }

  setArtWorkColor = (color) => {
    let activeObject = this.props.canvas._activeObject;
    let activeGroup = this.props.canvas.getActiveGroup();
    if(activeObject){
      if(activeObject.oldFill){
        activeObject.set({fill: color});
      }else{
        activeObject.set({fill: color,oldFill:color});
      }
      this.props.canvas.renderAll();
    }
    if(activeGroup){
      let objects = activeGroup._objects;
      objects.forEach(item=>{
        if(item.oldFill){
          item.set({fill: color});
        }else {
          item.set({fill: color,oldFill:item.fill});
        }
      })
      this.props.canvas.renderAll();
    }
    this.props.setSelectedMaterialColor(color)
    this.updateCanvasState();
  };
  updateCanvasState = () => {
    let tempConfig = this.props._config;
    if (tempConfig.undoStatus === false && tempConfig.redoStatus === false) {
      let jsonData = this.props.canvas.toJSON();
      let canvasAsJson = JSON.stringify(jsonData);
      if (tempConfig.currentStateIndex < tempConfig.canvasState.length - 1) {
        let indexToBeInserted = tempConfig.currentStateIndex + 1;
        tempConfig.canvasState[indexToBeInserted] = canvasAsJson;

        let numberOfElementsToRetain = indexToBeInserted + 1;
        tempConfig.canvasState = tempConfig.canvasState.splice(
            0,
            numberOfElementsToRetain
        );
      } else {
        tempConfig.canvasState.push(canvasAsJson);
      }

      tempConfig.currentStateIndex = tempConfig.canvasState.length - 1;

      if (
          tempConfig.currentStateIndex === tempConfig.canvasState.length - 1 &&
          tempConfig.currentStateIndex !== -1
      ) {
        tempConfig.redoButton = "disabled";
      }
    }
    this.props.setCanvasConfig(tempConfig);
  };
  clearSelection=()=>{
    $('.deleteBtn').css('visibility', 'hidden')
    $('.material-color-pane').css({ display: 'none' })
    $('.text-color-pane').css({ display: 'none' })

    $('#bold').removeClass('active')
    $('#italic').removeClass('active')
    $('#underline').removeClass('active')
    $('#capital').removeClass('active')
    $('#left-align').removeClass('active')
    $('#center-align').removeClass('active')
    $('#right-align').removeClass('active')
    $('.slct-font-size').val($('.slct-font-size option:first').val())
    $('.slct-font-fam').val($('.slct-font-fam option:first').val())
    $('#line_ht_get').val(1)
    $('#line_ht_get').css({
      background: `linear-gradient(to right, #1baa92 0%, #1baa92 5%, #fff 5%, #fff 100%)`,
    })
    $('#line_ht_set').val(1)
    $('#spacing_get').val(1)
    $('#spacing_get').css({
      background: `linear-gradient(to right, #1baa92 0%, #1baa92 5%, #fff 5%, #fff 100%)`,
    })
    $('#spacing_set').val(1)
    $('#text-color-bind').css({ background: 'black' })
    $('#size_get').val(0)
    $('#size_get').css({
      background: `linear-gradient(to right, #1baa92 0%, #1baa92 5%, #fff 5%, #fff 100%)`,
    })
    $('#size_set').val(0)
    $('#outline-color-bind').css({ background: 'black' })
    $('#selected_text').val('sampletext')
    $('.add-text-btn').text('Add Text')
  }
  deleteSelectedMaterial = () => {
    let activeObject = this.props.canvas._activeObject;
    if (activeObject) {
      this.props.canvas.remove(activeObject);
      this.props.removeRect(activeObject);
    }
    let activeGroup = this.props.canvas.getActiveGroup();
    console.log('group ',activeGroup);
    if(activeGroup){
      let objects = activeGroup._objects;
      this.props.canvas.deactivateAll().renderAll();
      objects.forEach(item=>{
        this.props.removeRect(item);
        this.props.canvas.remove(item);
      })
    }
    this.updateCanvasState();
    this.clearSelection();
    $(".second-menu").hide();
    $("#mats").show();
    $(`#menu li.nav.active`).removeClass("active");
    $(`#menu li.nav.mats`).addClass("active");
  };
  reStoreSelectedMaterial = () => {
    let activeObject = this.props.canvas._activeObject;
    let activeGroup = this.props.canvas.getActiveGroup();
    console.log('restore',activeGroup);
    if(activeObject){
      if(activeObject.oldFill){
        let fill = activeObject.oldFill;
        delete activeObject.oldFill;
        activeObject.set("fill", fill);
      }else{
        activeObject.set("fill", this.props.selectedMaterialColor);
      }
      this.props.canvas.renderAll();
    }
    if(activeGroup){
      let objects = activeGroup._objects;
      objects.forEach(item=>{
        if(item.oldFill){
          let fill = item.oldFill;
          delete item.oldFill;
          item.set({fill: fill});
        }
      })
      this.props.canvas.renderAll();
    }
    this.updateCanvasState();
  };

  render() {
    const activeColor = this.props.selectedMaterialColor;
    return(
        <>
          <div className="adddiv">
            <h2>EDIT ART WORK</h2>
          </div>
          <div className="templatesmain color-lft-blk-menu">
            <div className="row ">
              <div className="col-md-12">
                <div className="preset-color-row">
                  <div
                      className="pre-clr-box clr-pr1 tooltip"
                      style={{backgroundColor:activeColor}}
                  >
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-15">
                <ul className="nav nav-tabs nav-justified select-color-tab">
                  <li>
                    <a data-toggle="tab" href="#presets">
                      MAT COLORS
                    </a>
                  </li>
                </ul>
                <div className="tab-content slct-clr-tb-content">
                  <div id="presets" className="tab-pane fade in active">
                    <div className="preset-color-row">
                      <div
                          className="pre-clr-box clr-pr1 tooltip"
                          onClick={() => this.setArtWorkColor(SwainColorHex.RoyalBlue)}
                      >
                        <span className="tooltiptext">Royal Blue</span>
                      </div>
                      <div
                          className="pre-clr-box clr-pr2 tooltip"
                          onClick={() => this.setArtWorkColor(SwainColorHex.Red)}
                      >
                        <span className="tooltiptext">Red</span>
                      </div>
                      <div
                          className="pre-clr-box clr-pr3 tooltip"
                          onClick={() => this.setArtWorkColor(SwainColorHex.Gold)}
                      >
                        <span className="tooltiptext">Gold</span>
                      </div>
                    </div>
                    <div className="preset-color-row">
                      <div
                          className="pre-clr-box clr-pr4 tooltip"
                          onClick={() => this.setArtWorkColor(SwainColorHex.Black)}
                      >
                        <span className="tooltiptext">Black</span>
                      </div>
                      <div
                          className="pre-clr-box clr-pr21 tooltip"
                          onClick={() => this.setArtWorkColor(SwainColorHex.Gray)}
                      >
                        <span className="tooltiptext">Gray</span>
                      </div>
                      <div
                          className="pre-clr-box clr-pr22 tooltip"
                          onClick={() => this.setArtWorkColor(SwainColorHex.LightGreen)}
                      >
                        <span className="tooltiptext">Light Green</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-center'>
              <span className="btn col-md-2" style={{border:'1px solid white',margin:'10px 10px 10px 10px'}}>
                <a className='custom-side-nav1' onClick={() => this.reStoreSelectedMaterial()}>
                  <img src={require("./../../../assets/img/redo.png")} alt="redo" style={{height:'20px',width:'18px'}} />
                </a>
              </span>
              <span className="btn col-md-2" style={{border:'1px solid white',margin:'10px 10px 10px 0px'}}>
                <a className='custom-side-nav1' onClick={() => this.deleteSelectedMaterial()}>
                  <img src={require("./../../../assets/img/del.png")} alt="del" style={{height:'20px',width:'18px'}} />
                </a>
              </span>
              {/*<button
                  className="btn col-md-2"
                  style={{margin:'10px',backgroundColor:'#34405a'}}
                  onClick={() => this.reStoreSelectedMaterial()}
              >
                <img
                    src={require("./../../../assets/img/redo.png")}
                    alt="redo"
                ></img>
              </button>
              <button
                  className="btn col-md-2"
                  style={{margin:'10px',backgroundColor:'#34405a'}}
                  onClick={() => this.deleteSelectedMaterial()}
              >
                <img
                    src={require("./../../../assets/img/del.png")}
                    alt="del"
                ></img>
              </button>*/}
            </div>
          </div>
        </>
    )
  }
}
const EditArtWorkToolbarConnect = connect(
    mapStateToProps,
    mapDispatchToPropsForRect
)(EditArtWorkToolbar);

class EditArtWorkSidebar extends React.Component {
  closeNav1 = () => {
    document.getElementById("mySidenav5").style.width = "0";
  };

  render() {
    return(
        <>
          <div id="artwork" className="h100 second-menu fordeskview">
            <EditArtWorkToolbarConnect />
          </div>
          <div
              className="text-center h100 pad0 mtopneg sidenav1 formobview wo"
              id="mySidenav5"
          >
            <a
                style={{ color: "#fff" }}
                href="#"
                className="closebtn"
                onClick={() => this.closeNav1()}
            >
              &times;
            </a>
            <EditArtWorkToolbarConnect />
          </div>
        </>
    )
  }
}

class TemplatesToolbar extends React.Component {

  addNewTemplate = e => {
    const {swain_config} = this.props;
    let template_type = e.target.alt;
    this.props.setNewTemplateConfig(template_type);
    this.props.setDragTemplate(true);
    const templates_width = this.props.templates_width;
    const unit = swain_config.length_unit === "FEET"?3.28:1;
    const width = templates_width[template_type].width * this.props.canvas_grid * unit * this.props.zoom;
    const height = templates_width[template_type].height * this.props.canvas_grid * unit * this.props.zoom;
    let img_template = $("<img />", {
      src: require("./../../../assets/img/" + template_type + ".jpg"),
      id: "dragged_template",
      width,
      height,
      display: "none"
    });
    $("#drag_template").html(img_template);
    const top = e.pageY - height / 2;
    const left = e.pageX - width / 2;
    console.log({top,left});
    $("#dragged_template").css({
      position: "fixed",
      top: top,
      left: left
    });
    let previewed_image = $("<img />", {
      src: require("./../../../assets/img/preview.png"),
      id: "previewed_image",
      width: width,
      height: height,
      display: "none"
    });
    $("#preview_image").html(previewed_image);
    $('#previewed_image').css({
      display: 'none',
    })
    document.getElementById("mySidenav1").style.width = "0";
    document.getElementById("mySidenav2").style.width = "0";
    document.getElementById("mySidenav3").style.width = "0";
    document.getElementById("mySidenav4").style.width = "0";
  };
  checkBrowser=()=>{
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };
  _mouseOver=(e)=>{
    if(this.checkBrowser()) return;
    let boundingBox = e.target.getBoundingClientRect();
    $("#tooltiptemplate").css({top:boundingBox.top+boundingBox.height , left:boundingBox.left+boundingBox.width,visibility:'visible' });
  }
  _mouseOut=()=>{
    if(this.checkBrowser()) return;
    $("#tooltiptemplate").css({visibility:'hidden' });
  }
  render() {
    return (
        <>
          <div className="adddiv">
            <h2>Templates</h2>
          </div>
          <div className="templatesmain">
            <div className="col-md-6 col-sm-6">
              <div className="temrows">
                <div>
                  <img
                      src={require("./../../../assets/img/template1.jpg")}
                      alt="template1"
                      onDragStart={this.addNewTemplate}
                      style={{width: "121px", height: "121px"}}
                  />
                </div>

              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="temrows">
                <div>
                  <img
                      src={require("./../../../assets/img/template2.jpg")}
                      alt="template2"
                      onDragStart={this.addNewTemplate}
                      style={{width: "121px", height: "121px"}}
                  />
                </div>

              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="temrows">
                <div>
                  <img
                      src={require("./../../../assets/img/template3.jpg")}
                      alt="template3"
                      onDragStart={this.addNewTemplate}
                      style={{width: "121px", height: "121px"}}
                  />
                </div>

              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="temrows">
                <div>
                  <img
                      src={require("./../../../assets/img/template4.jpg")}
                      alt="template4"
                      onDragStart={this.addNewTemplate}
                      style={{width: "121px", height: "121px"}}
                  />
                </div>

              </div>
            </div>
            <div className="col-md-12">
              <div className="temrows">
                <div>
                  <img
                      src={require("./../../../assets/img/template5.jpg")}
                      alt="template5"
                      onDragStart={this.addNewTemplate}
                      style={{width: "230px"}}
                  />
                </div>

              </div>
            </div>
            <div className="col-md-12">
              <div className="temrows">
                <div>
                  <img
                      src={require("./../../../assets/img/template15.jpg")}
                      alt="template15"
                      onDragStart={this.addNewTemplate}
                      style={{width: "230px"}}
                  />
                </div>

              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="temrows">
                <div>
                  <img
                      src={require("./../../../assets/img/template6.jpg")}
                      alt="template6"
                      onDragStart={this.addNewTemplate}
                      style={{width: "121px", height: "121px"}}
                  />
                </div>

              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="temrows">
                <div>
                  <img
                      src={require("./../../../assets/img/template7.jpg")}
                      alt="template7"
                      onDragStart={this.addNewTemplate}
                      style={{width: "121px", height: "121px"}}
                  />
                </div>

              </div>
            </div>

            <div className="col-md-6 col-sm-6">
              <div className="temrows">
                <img
                    src={require("./../../../assets/img/template8.jpg")}
                    alt="template8"
                    onDragStart={this.addNewTemplate}
                    style={{width: "121px", height: "121px"}}
                />
              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="temrows">
                <img
                    src={require("./../../../assets/img/template9.jpg")}
                    alt="template9"
                    onDragStart={this.addNewTemplate}
                    style={{width: "121px", height: "121px"}}
                />
              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="temrows">
                <img
                    src={require("./../../../assets/img/template10.jpg")}
                    alt="template10"
                    onDragStart={this.addNewTemplate}
                    style={{width: "121px", height: "121px"}}
                />
              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="temrows">
                <img
                    src={require("./../../../assets/img/template11.jpg")}
                    alt="template11"
                    onDragStart={this.addNewTemplate}
                    style={{width: "121px", height: "121px"}}
                />
              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="temrows">
                <img
                    src={require("./../../../assets/img/template12.jpg")}
                    alt="template12"
                    onDragStart={this.addNewTemplate}
                    style={{width: "121px", height: "121px"}}
                />
              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="temrows">
                <img
                    src={require("./../../../assets/img/template13.jpg")}
                    alt="template13"
                    onDragStart={this.addNewTemplate}
                    style={{width: "121px", height: "121px"}}
                />
              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="temrows">
                <img
                    src={require("./../../../assets/img/template14.jpg")}
                    alt="template14"
                    onDragStart={this.addNewTemplate}
                    style={{width: "121px", height: "121px"}}
                />
              </div>
            </div>
          </div>
        </>
    );
  }
}

const setDragTemplate = drag_new_template => {
  return {
    type: "DRAG_NEW_TEMPLATE",
    drag_new_template: drag_new_template
  };
};

const setNewTemplateConfig = template_type => {
  return {
    type: "NEW_TEMPLATE_CONFIG",
    template_type: template_type
  };
};

const mapDispatchToPropsForTemplate = dispatch => {
  return bindActionCreators(
    { setNewTemplateConfig, setDragTemplate },
    dispatch
  );
};

const TemplatesToolbarConnect = connect(
  mapStateToProps,
  mapDispatchToPropsForTemplate
)(TemplatesToolbar);

class TemplateToolSidebar extends React.Component {
  closeNav2 = () => {
    document.getElementById("mySidenav2").style.width = "0";
  };

  render() {
    return (
      <>
        <div
          id="template"
          className="h100 second-menu fordeskview"
          style={{ display: "none" }}
        >
          <TemplatesToolbarConnect />
        </div>
        <div
          className="text-center h100 pad0 mtopneg sidenav2 formobview wo"
          id="mySidenav2"
        >
          <a
            style={{ color: "#fff" }}
            href="#"
            className="closebtn"
            onClick={() => this.closeNav2()}
          >
            &times;
          </a>
          <TemplatesToolbarConnect />
        </div>
      </>
    );
  }
}

const TextStyle = props => {
  return (
    <>
      <div id="text-style" className="row">
        <div
          id="text-style-1"
          className="col-md-6 col-sm-12 text-style_1"
          onClick={() => props.setTextArcStyle("text-style-1")}
        >
          <img
            src={require("./../../../assets/img/text-style_1.png")}
            alt="style_1"
            onClick={() => props.setTextArcStyle("text-style-1")}
          />
        </div>
        <div
          id="text-style-2"
          className="col-md-6 col-sm-12 text-style_2"
          onClick={() => props.setTextArcStyle("text-style-2")}
        >
          <img
            src={require("./../../../assets/img/text-style_2.png")}
            alt="style_2"
            onClick={() => props.setTextArcStyle("text-style-2")}
          />
        </div>
      </div>
    </>
  );
};

class TextToolbar extends React.Component {
  addNewText = () => {
    let new_text = $("#selected_text").val();
    if (new_text === "") {
      alert("Please input the text");
      return;
    }
    let text = this.props.canvas._objects[0];
    let data = {
      text: new_text,
      top: text.top,
      left: text.left,
      fontSize: 20,
      fontWeight: text.get("fontWeight"),
      fontStyle: text.get("fontStyle"),
      textDecoration: text.get("textDecoration"),
      lineHeight: text.get("lineHeight"),
      fill: text.get("fill"),
      strokeWidth: text.get("strokeWidth") / 1,
      stroke: text.get("stroke"),
      letterSpace: text.letterSpace,
      effect: "STRAIGHT"
    };

    this.props.setComponentType('StraightText');
    this.props.addNewText(new window.fabric.CurvedText(data.text, data));
    this.props.setCurvedTextStyle(data)
  };

  updateCanvasState = () => {
    let tempConfig = this.props._config;
    if (tempConfig.undoStatus === false && tempConfig.redoStatus === false) {
      let jsonData = this.props.canvas.toJSON();
      let canvasAsJson = JSON.stringify(jsonData);
      if (tempConfig.currentStateIndex < tempConfig.canvasState.length - 1) {
        let indexToBeInserted = tempConfig.currentStateIndex + 1;
        tempConfig.canvasState[indexToBeInserted] = canvasAsJson;

        let numberOfElementsToRetain = indexToBeInserted + 1;
        tempConfig.canvasState = tempConfig.canvasState.splice(
          0,
          numberOfElementsToRetain
        );
      } else {
        tempConfig.canvasState.push(canvasAsJson);
      }

      tempConfig.currentStateIndex = tempConfig.canvasState.length - 1;

      if (
        tempConfig.currentStateIndex === tempConfig.canvasState.length - 1 &&
        tempConfig.currentStateIndex !== -1
      ) {
        tempConfig.redoButton = "disabled";
      }
    }
    this.props.setCanvasConfig(tempConfig);
  };

  setTextStyle = id => {
    let activeObject = this.props.canvas._activeObject;
    if (activeObject == null) return;

    let targetClsName = $("#" + id).attr("class");
    const textStyleOption = id;
    if (targetClsName.indexOf("active") > -1) {
      $("#" + id).removeClass("active");
      switch (textStyleOption) {
        case "bold":
          activeObject.set("fontWeight", "normal");
          break;
        case "italic":
          activeObject.set("fontStyle", "");
          break;
        case "underline":
          activeObject.set("textDecoration", "");
          break;
        case "capital":
          activeObject.text = activeObject.text.toLowerCase();
          break;
        case "left-align":
        case "center-align":
        case "right-align":
          activeObject.set("textAlign", "left");
          break;
        default:
          break;
      }
    } else {
      $("#" + id).addClass("active");
      switch (textStyleOption) {
        case "bold":
          activeObject.set("fontWeight", "bold");
          break;
        case "italic":
          activeObject.set("fontStyle", "italic");
          break;
        case "underline":
          activeObject.set("textDecoration", "underline");
          break;
        case "capital":
          activeObject.text = activeObject.text.toUpperCase();
          break;
        case "left-align":
          activeObject.set("textAlign", "left");
          $("#center-align").removeClass("active");
          $("#right-align").removeClass("active");
          break;
        case "center-align":
          activeObject.set("textAlign", "center");
          $("#left-align").removeClass("active");
          $("#right-align").removeClass("active");
          break;
        case "right-align":
          activeObject.set("textAlign", "right");
          $("#center-align").removeClass("active");
          $("#left-align").removeClass("active");
          break;
        default:
          break;
      }
    }
    this.props.canvas.renderAll();
    this.updateCanvasState();
  };

  setFontSize = e => {
    let { value } = e.target;

    let fontSize = value.replace("px", "");

    let activeObject = this.props.canvas._activeObject;
    if (activeObject == null) return;

    activeObject.set("fontSize", fontSize);
    this.props.canvas.renderAll();
    this.updateCanvasState();
  };

  setLineHeight = e => {
    let { value } = e.target;
    $("#line_ht_get").val(value);
    $("#line_ht_set").val(value);

    $("#line_ht_get").css({
      background: `linear-gradient(to right, #1baa92 0%, #1baa92 ${value *
        9}%, #fff ${value * 9}%, #fff 100%)`
    });

    let activeObject = this.props.canvas._activeObject;
    if (activeObject == null) return;

    activeObject.set("lineHeight", value);
    this.props.canvas.renderAll();
    this.updateCanvasState();
  };

  bindTextColorBtn = () => {
    let activeObject = this.props.canvas._activeObject;
    if (activeObject == null) return;

    $(".material-color-pane").css({ display: "none" });
    $(".circle-color-pane").css({ display: "none" });
    $(".text-color-pane").css({ display: "block" });
    $(".advanced_span").css({ display: "block" });
    $(".custom-colors").css({ display: "block" });
    $("#text-custom").css({ display: "block" });
    $(".custom-colors div.active").removeClass("active");
    $(".text-custom-color").addClass("active");
    $("#text-rgb").css({ display: "none" });
    $("#text-cmyk").css({ display: "none" });
    this.props.setTextColorOption("fill");
  };

  setTextColor = e => {
    let { value } = e.target;
    $("#text-color-bind").css({ background: value });

    let activeObject = this.props.canvas._activeObject;
    if (activeObject == null) return;

    activeObject.set("fill", value);
    this.props.canvas.renderAll();
    this.updateCanvasState();
  };

  setOutlineSize = e => {
    let { value } = e.target;

    $("#size_get").val(value);
    $("#size_set").val(value);

    $("#size_get").css({
      background: `linear-gradient(to right, #1baa92 0%, #1baa92 ${value *
        10}%, #fff ${value * 10}%, #fff 100%)`
    });

    let activeObject = this.props.canvas._activeObject;
    if (activeObject == null) return;

    activeObject.set("strokeWidth", value / 1);
    this.props.canvas.renderAll();
    this.updateCanvasState();
  };

  bindOutlineColorBtn = () => {
    let activeObject = this.props.canvas._activeObject;
    if (activeObject == null) return;

    $(".material-color-pane").css({ display: "none" });
    $(".circle-color-pane").css({ display: "none" });
    $(".text-color-pane").css({ display: "block" });
    $(".advanced_span").css({ display: "block" });
    $(".custom-colors").css({ display: "block" });
    $("#text-custom").css({ display: "block" });
    $(".custom-colors div.active").removeClass("active");
    $(".text-custom-color").addClass("active");
    $("#text-rgb").css({ display: "none" });
    $("#text-cmyk").css({ display: "none" });
    this.props.setTextColorOption("stroke");
  };

  setOutlineColor = e => {
    let { value } = e.target;
    $("#outline-color-bind").css({ background: value });

    let activeObject = this.props.canvas._activeObject;
    if (activeObject == null) return;

    activeObject.set("stroke", value);
    this.props.canvas.renderAll();
    this.updateCanvasState();
  };

  setTextArcStyle = text_arc_style => {
    let activeObject = this.props.canvas._activeObject;
    if (activeObject == null) return;

    let data = {}
    switch (text_arc_style) {
      case "text-style-1":
        data = {
          text: activeObject.text,
          top: activeObject.top,
          left: activeObject.left,
          fontFamily: activeObject.get('fontFamily'),
          fontSize: activeObject.get("fontSize"),
          fontWeight: activeObject.get("fontWeight"),
          fontStyle: activeObject.get("fontStyle"),
          textDecoration: activeObject.get("textDecoration"),
          lineHeight: activeObject.get("lineHeight"),
          fill: activeObject.get("fill"),
          strokeWidth: activeObject.get("strokeWidth") / 1,
          stroke: activeObject.get("stroke"),
          letterSpace: activeObject.letterSpace,
          effect: "vertical"
        };

        this.props.canvas.remove(activeObject);
        this.props.setComponentType("VerticalText");
        this.props.addNewText(new window.fabric.VerticalText(data.text, data));
        this.props.setCurvedTextStyle(data);
        break;
      case "text-style-2":
        data = {
          text: activeObject.text,
          top: activeObject.top,
          left: activeObject.left,
          fontFamily: activeObject.get('fontFamily'),
          fontSize: activeObject.get("fontSize"),
          fontWeight: activeObject.get("fontWeight"),
          fontStyle: activeObject.get("fontStyle"),
          textDecoration: activeObject.get("textDecoration"),
          lineHeight: activeObject.get("lineHeight"),
          fill: activeObject.get("fill"),
          strokeWidth: activeObject.get("strokeWidth") / 1,
          stroke: activeObject.get("stroke"),
          letterSpace: activeObject.letterSpace,
          effect: "curved"
        };

        this.props.canvas.remove(activeObject);
        this.props.setComponentType("Curvedtext");
        this.props.addNewText(new window.fabric.CurvedText(data.text, data));
        this.props.setCurvedTextStyle(data);
        break;
      default:
        break;
    }
  };

  setLetterSpace = e => {
    let { value } = e.target;
    $("#spacing_get").val(value);
    $("#spacing_set").val(value);

    $("#spacing_get").css({
      background: `linear-gradient(to right, #1baa92 0%, #1baa92 ${value}%, #fff ${value}%, #fff 100%)`
    });

    let activeObject = this.props.canvas._activeObject;
    if (activeObject == null) return;

    activeObject.set("spacing", value);
    this.props.canvas.renderAll();
    this.updateCanvasState();
  };

  setFontFamily = e => {
    let { value } = e.target;

    let activeObject = this.props.canvas._activeObject;
    if (activeObject == null) return;

    let font = new FontFaceObserver(value);
    font
      .load()
      .then(() => {
        activeObject.set("fontFamily", value);
        this.props.canvas.renderAll();
      })
      .catch(e => {});

    this.updateCanvasState();
  };

  setRadius = e => {
    let { value } = e.target;
    $("#arc_get").val(value);
    $("#arc_set").val(value);

    $("#arc_get").css({
      background: `linear-gradient(to right, #1baa92 0%, #1baa92 ${value *
        2}%, #fff ${value}%, #fff 100%)`
    });

    let activeObject = this.props.canvas._activeObject;
    if (activeObject == null) return;

    if (
      activeObject.effect === "arc" ||
      activeObject.effect === "flag" ||
      activeObject.effect === "curved"
    ) {
      activeObject.set("radius", 500 - (20 * value) / 1);
      this.props.canvas.renderAll();
      this.updateCanvasState();
    }
  };

  render() {
    return (
      <>
        <div className="adddiv fh">
          <h2>Add Text</h2>
          <div className="add-new-txt">
            <div className="row row-border-btm">
              <div className="col-md-12">
                <div className="pb-15" style={{ display: "inline-flex" }}>
                  <div className="new-text-input">
                    <input
                      type="text"
                      id="selected_text"
                      defaultValue="Your Text"
                    ></input>
                  </div>
                  <div className="new-text-input">
                    <button
                      className="btn green-btn btn-success add-text-btn"
                      onClick={() => this.addNewText()}
                    >
                      Add Text
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="add-text-blk-hmenu">
            <div className="font-select">
              <div className="row row-border-btm pt-15">
                <div className="col-md-8 vrtcl-dot-line">
                  <div className="form-group">
                    <select
                      className="form-control slct-font-fam"
                      onChange={this.setFontFamily}
                    >
                      <option>Times New Roman</option>
                      <option>Celtic</option>
                      <option>Martel</option>
                      <option>FM College Team Outline</option>
                      <option>FM College Team</option>
                      <option>lvy League</option>
                      <option>lvy League Outline</option>
                      <option>Blackjack</option>
                      <option>Ball Park</option>
                      <option>Century Gothic</option>
                      <option>Major Snafu</option>
                      <option>Stencil Becker Solid</option>
                      <option>Freshman</option>
                      <option>InterState</option>
                      <option>Machine BT</option>
                      <option>Rockwell Condensed</option>
                      <option>Rockwell</option>
                      <option>Times New Roman</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <select
                      className="form-control slct-font-size"
                      onChange={this.setFontSize}
                    >
                      <option val="20">20px</option>
                      <option val="22">22px</option>
                      <option val="24">24px</option>
                      <option val="26">26px</option>
                      <option val="28">28px</option>
                      <option val="30">30px</option>
                      <option val="32">32px</option>
                      <option val="34">34px</option>
                      <option val="36">36px</option>
                      <option val="38">38px</option>
                      <option val="40">40px</option>
                      <option val="42">42px</option>
                      <option val="44">44px</option>
                      <option val="46">46px</option>
                      <option val="48">48px</option>
                      <option val="50">50px</option>
                      <option val="52">52px</option>
                      <option val="54">54px</option>
                      <option val="56">56px</option>
                      <option val="58">58px</option>
                      <option val="60">60px</option>
                      <option val="62">62px</option>
                      <option val="64">64px</option>
                      <option val="66">66px</option>
                      <option val="68">68px</option>
                      <option val="70">70px</option>
                      <option val="72">72px</option>
                      <option val="74">74px</option>
                      <option val="76">76px</option>
                      <option val="78">78px</option>
                      <option val="80">80px</option>
                      <option val="85">85px</option>
                      <option val="90">90px</option>
                      <option val="95">95px</option>
                      <option val="100">100px</option>
                      <option val="110">110px</option>
                      <option val="120">120px</option>
                      <option val="130">130px</option>
                      <option val="140">140px</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="row row-border-btm pt-15 pb-15">
                <div className="col-md-7 vrtcl-dot-line">
                  <div className="font-stl-blk">
                    <button
                      id="bold"
                      className="btn stl-btn"
                      onClick={() => this.setTextStyle("bold")}
                    >
                      B
                    </button>
                    <button
                      id="italic"
                      className="btn stl-btn"
                      onClick={() => this.setTextStyle("italic")}
                    >
                      <i>I</i>
                    </button>
                    <button
                      id="underline"
                      className="btn stl-btn"
                      onClick={() => this.setTextStyle("underline")}
                    >
                      <span>U</span>
                    </button>
                    <button
                      id="capital"
                      className="btn stl-btn"
                      onClick={() => this.setTextStyle("capital")}
                    >
                      AA
                    </button>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="font-stl-blk">
                    <button
                      id="left-align"
                      className="btn stl-btn"
                      onClick={() => this.setTextStyle("left-align")}
                    ></button>
                    <button
                      id="center-align"
                      className="btn stl-btn"
                      onClick={() => this.setTextStyle("center-align")}
                    ></button>
                    <button
                      id="right-align"
                      className="btn stl-btn"
                      onClick={() => this.setTextStyle("right-align")}
                    ></button>
                  </div>
                </div>
              </div>
              <div className="row pt-15 pb-15">
                <div className="col-md-12">
                  <div className="line-height-blk">
                    <div className="line-height-label">
                      <span>Line height</span>
                    </div>
                    <div className="line-height-label">
                      <div className="range-slidecontainer">
                        <input
                          type="range"
                          min="1"
                          max="10"
                          defaultValue="1"
                          className="range-slider"
                          id="line_ht_get"
                          onChange={this.setLineHeight}
                        ></input>
                      </div>
                    </div>
                    <div className="line-height-value">
                      <input
                        type="number"
                        id="line_ht_set"
                        className="btn ln-ht-val-btn"
                        defaultValue="1"
                        min="1"
                        max="10"
                        onChange={this.setLineHeight}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="spacing-blk pt-10">
                    <div className="spacing-label">
                      <span>Spacing</span>
                    </div>
                    <div className="spacing-slider">
                      <div className="range-slidecontainer">
                        <input
                          type="range"
                          min="1"
                          max="100"
                          defaultValue="1"
                          className="range-slider"
                          id="spacing_get"
                          onChange={this.setLetterSpace}
                        ></input>
                      </div>
                    </div>
                    <div className="spacing-value">
                      <input
                        type="number"
                        id="spacing_set"
                        min="1"
                        max="100"
                        className="btn spacing-val-btn"
                        defaultValue="1"
                        onChange={this.setLetterSpace}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="choose-clr-blk pt-10">
                    <div className="choos-clr-label">
                      <span>Choose Color</span>
                    </div>
                    <div className="choos-clr-btn">
                      <button
                        id="text-color-bind"
                        className="btn"
                        onClick={() => this.bindTextColorBtn()}
                      ></button>
                      <input
                        type="color"
                        id="text-color"
                        className="btn"
                        defaultValue="black"
                        onChange={this.setTextColor}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="outline-blk pt-15">
            <h2>ADD OUTLINE</h2>
          </div>
          <div className="add-text-blk-hmenu">
            <div className="font-select">
              <div className="row">
                <div className="col-md-12">
                  <div className="size-blk pt-10">
                    <div className="size-label">
                      <span>Size</span>
                    </div>
                    <div className="size-slider">
                      <div className="range-slidecontainer">
                        <input
                          type="range"
                          min="1"
                          max="10"
                          defaultValue="1"
                          className="range-slider"
                          id="size_get"
                          onChange={this.setOutlineSize}
                        ></input>
                      </div>
                    </div>
                    <div className="size-value">
                      <input
                        type="number"
                        id="size_set"
                        className="btn size-val-btn"
                        min="1"
                        max="10"
                        defaultValue="1"
                        onChange={this.setOutlineSize}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="choose-clr-blk pt-10">
                    <div className="choos-clr-label">
                      <span>Choose Color</span>
                    </div>
                    <div className="choos-clr-btn">
                      <button
                        id="outline-color-bind"
                        className="btn"
                        onClick={() => this.bindOutlineColorBtn()}
                      ></button>
                      <input
                        type="color"
                        id="outline-color"
                        className="btn"
                        onChange={this.setOutlineColor}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="shape-blk">
            <h2>ARC or VERTICAL TEXT</h2>
          </div>
          <div className="add-text-blk-hmenu">
            <div className="font-select">
              <div className="row">
                <div className="col-md-12">
                  <div className="font-stl-blk pt-10">
                    <div className="choos-clr-label float-left">
                      <span>Text Style</span>
                    </div>
                    <div className="choose-button-blk float-right">
                      <Popover
                        placement="right"
                        content={
                          <TextStyle setTextArcStyle={this.setTextArcStyle} />
                        }
                        trigger="click"
                      >
                        <button className="btn choose-btn">CHOOSE </button>
                      </Popover>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="arc-blk pt-10">
                    <div className="arc-label">
                      <span>Arc</span>
                    </div>
                    <div className="arc-slider">
                      <div className="range-slidecontainer">
                        <input
                          type="range"
                          min="1"
                          max="50"
                          defaultValue="1"
                          className="range-slider"
                          id="arc_get"
                          onChange={this.setRadius}
                        />
                      </div>
                    </div>
                    <div className="arc-value">
                      <input
                        type="number"
                        id="arc_set"
                        min="1"
                        max="50"
                        className="btn size-val-btn"
                        defaultValue="1"
                        onChange={this.setRadius}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const setComponentType = type => {
  return {
    type: 'SET_COMPONENT_TYPE',
    component_type: type,
  }
}

const addNewText = text => {
  return {
    type: "NEW_TEXT",
    component: text
  };
};

const addNewCurvedText = (curvedText, data) => {
  return {
    type: "NEW_CURVED_TEXT",
    component: curvedText,
    data: data
  };
};

const setCurvedTextStyle = data => {
  return {
    type: "SET_CURVEDTEXT_STLYE",
    data: data
  };
};

const setCanvasConfig = _config => {
  return {
    type: "SET_CONFIG",
    _config
  };
};
const removeRect = (data) => {
  return {
    type: "REMOVE_RECT",
    data,
  };
};
const setSelectedMaterialColor = color => {
  return {
    type: 'SET_SELECTEED_MATERIAL_COLOR',
    color: color,
  }
}

const setLetterSpacingOption = option => {
  return {
    type: "SET_LETTER_SPACING_OPTION",
    option: option
  };
};

const setSelectedText = text => {
  return {
    type: "SET_SELECTED_TEXT",
    text: text
  };
};

const setTextColorOption = option => {
  return {
    type: "SET_TEXT_COLOR_OPTION",
    option
  };
};

const mapDispatchToPropsForText = dispatch => {
  return bindActionCreators(
    {
      addNewText,
      setComponentType,
      addNewCurvedText,
      setCurvedTextStyle,
      setCanvasConfig,
      setLetterSpacingOption,
      setSelectedText,
      setTextColorOption
    },
    dispatch
  );
};

const TextToolbarConnect = connect(
  mapStateToProps,
  mapDispatchToPropsForText
)(TextToolbar);

class TextToolSidebar extends React.Component {
  closeNav3 = () => {
    document.getElementById("mySidenav3").style.width = "0";
  };

  render() {
    return (
      <>
        <div
          id="text"
          className="h100 second-menu fordeskview"
          style={{ display: "none" }}
        >
          <TextToolbarConnect />
        </div>
        <div
          className="text-center h100 pad0 mtopneg sidenav3 formobview wo"
          id="mySidenav3"
        >
          <a
            style={{ color: "#fff" }}
            href="#"
            className="closebtn"
            onClick={() => this.closeNav3()}
          >
            &times;
          </a>
          <TextToolbarConnect />
        </div>
      </>
    );
  }
}

const ImageList = props => {
  const files = props.files;
  if (files.length <= 0) return <div />;
  else
    return files.map((file, idx) => (
      <div className="col-md-4" key={`div_${idx}`}>
        <img
          src={require(`./../../../../icons/${file}`)}
          alt=""
          key={idx}
          onClick={props.addNewLogo}
        />
      </div>
    ));
};
class LogoToolbar extends React.Component {
  state = {
    files: []
  };

  componentDidMount = () => {
    axios
      .post("/api/logo_images")
      .then(res => {
        // this.setState({ files: res.data });
      })
      .catch(err => {
        console.log(err);
      });
  };

  bindFileExplorer = () => {
    $("#customFile").click();
  };

  onChangeHandler = e => {
    e.preventDefault()
    const reader = new FileReader();
    const files = e.target.files;
    const logos = [];
    let i = 0;

    reader.onload = re => {
      var img = new Image();
      img.src = re.target.result;
      logos.push({
        filename: files[i-1].name,
        href: re.target.result
      });
      img.onload = () => {
        var fabImage = new window.fabric.Image(img);
        fabImage.set({
          left: 0,
          top: 0,
          hoverCursor: 'default',
        });
        if (img.width > img.height) {
          fabImage.scaleToWidth(this.props.canvas.getWidth() / 1.5);
        } else {
          fabImage.scaleToHeight(this.props.canvas.getHeight() / 1.5);
        }
        this.props.canvas.add(fabImage);

        if (i < files.length) {
          reader.readAsDataURL(files[i++])
        } else {
          this.props.canvas.renderAll();
          this.props.setUploadLogos(logos);
        }
      }
    }

    reader.readAsDataURL(files[i++])
  };

  addNewLogo = e => {
    let { src } = e.target;
    this.props.setImageUrl(src);
    window.fabric.Image.fromURL(
      require("./../../../assets/img/profile.jpg"),
      image => {
        image.scale(0.5);
        image.set({
          left: 0,
          top: 0,
          hoverCursor: "default"
        });

        this.props.addNewImage(image);
      }
    );
  };

  render() {
    const files = this.state.files;
    return (
      <>
        <div className="row adddiv">
          <h2>Add Logo</h2>
        </div>
        <div className="row adddiv">
          <p
            onClick={() => this.bindFileExplorer()}
            style={{ cursor: "pointer" }}
          >
            Upload your own images from computer
          </p>
          <input
            type="file"
            multiple
            className="custom-file-input"
            id="customFile"
            name="files"
            onChange={this.onChangeHandler}
          />
          <small>
            <i>Accepted Files : SVG, JPG, JPEG, PNG</i>
          </small>
        </div>
        <div className="row image_list">
          <ImageList files={files} addNewLogo={this.addNewLogo} />
        </div>
      </>
    );
  }
}

const setImageUrl = url => {
  return {
    type: "SET_IMAGE_URL",
    image_url: url
  };
};

const setUploadLogos = logos => {
  return {
    type: "SET_UPLOADED_LOGOS",
    logos
  };
};

const addNewImage = image => {
  return {
    type: "NEW_IMAGE",
    component: image
  };
};

const mapDispatchToPropsForLogo = dispatch => {
  return bindActionCreators({ setImageUrl, addNewImage, setUploadLogos }, dispatch);
};

const LogoToolbarConnect = connect(
  mapStateToProps,
  mapDispatchToPropsForLogo
)(LogoToolbar);

class LogoToolSidebar extends React.Component {
  closeNav4 = () => {
    document.getElementById("mySidenav4").style.width = "0";
  };

  render() {
    return (
      <>
        <div
          id="logo"
          className="h100 second-menu fordeskview"
          style={{ display: "none" }}
        >
          <LogoToolbarConnect />
        </div>
        <div
          className="text-center h100 pad0 mtopneg sidenav4 formobview wo"
          id="mySidenav4"
        >
          <a
            style={{ color: "#fff" }}
            href="#"
            className="closebtn"
            onClick={() => this.closeNav4()}
          >
            &times;
          </a>
          <LogoToolbarConnect />
        </div>
      </>
    );
  }
}

class SidebarItemsDesktop extends React.Component {
  emptyClick= () =>{
    document.getElementById('second-custom-right').style.display = 'none'
    document.getElementById("mySidenav1").style.width = "0";
    document.getElementById("mySidenav2").style.width = "0";
    document.getElementById("mySidenav3").style.width = "0";
    document.getElementById("mySidenav4").style.width = "0";
  }

  render() {
    return (
      <>
        <MatsToolSidebar />
        <TemplateToolSidebar />
        <TextToolSidebar />
        <LogoToolSidebar />
        <EditArtWorkSidebar />
        <div id="second-custom-right" onClick={this.emptyClick}/>
      </>
    );
  }
}

export default SidebarItemsDesktop;
